import { ApiClient, PagedResults, ServiceResponse } from "../../../common";
import { PlatformSettings } from "../../../settings/platformSettings";
import { EventSearchParamsDto } from "../../dtos/in/eventSearchParamsDto";
import { CategoryDto } from "../../dtos/out/categoryDto";
import { EventDto } from "../../dtos/out/eventDto";
import { IEventsClient } from "../interfaces/eventsClient";

class EventsClient extends ApiClient implements IEventsClient {

    private _baseUrl: string;
    constructor(private platformSettings: PlatformSettings) {
        super();
        this._baseUrl = platformSettings.apiUrl + "/events";
    }

    get baseUrl(): string {
        return this._baseUrl;
    }

    public async searchEvents(searchParams: EventSearchParamsDto, accessToken: string): Promise<ServiceResponse<PagedResults<EventDto>>> {

        // add searchParams to url
        let resourceUrl = `search-results?page=${searchParams.page}&pageSize=${searchParams.pageSize}`;

        if (searchParams.searchTerm) {
            resourceUrl += `&searchTerm=${searchParams.searchTerm}`;
        }

        if (searchParams.eventId) {
            resourceUrl += `&eventId=${searchParams.eventId}`;
        }

        if (searchParams.partnerId) {
            resourceUrl += `&partnerId=${searchParams.partnerId}`;
        }

        if (searchParams.categoryIds) {

            searchParams.categoryIds.forEach(categoryId => {
                resourceUrl += `&categoryIds=${categoryId}`;
            });
        }

        if (searchParams.location) {
            resourceUrl += `&location=${searchParams.location}`;
        }

        if (searchParams.distance > 0) {
            resourceUrl += `&distance=${searchParams.distance}`;
        }

        if (searchParams.lat) {
            resourceUrl += `&lat=${searchParams.lat}`;
        }

        if (searchParams.lon) {
            resourceUrl += `&lon=${searchParams.lon}`;
        }

        if (searchParams.minPrice) {
            resourceUrl += `&minPrice=${searchParams.minPrice}`;
        }

        if (searchParams.maxPrice) {
            resourceUrl += `&maxPrice=${searchParams.maxPrice}`;
        }

        if (searchParams.before) {
            resourceUrl += `&before=${searchParams.before.toISOString()}`;
        }

        if (searchParams.after) {
            resourceUrl += `&after=${searchParams.after.toISOString()}`;
        }

        if (searchParams.sortBy) {
            resourceUrl += `&sortBy=${searchParams.sortBy}`;
        }

        if (searchParams.showAvailableEventsOnly) {
            resourceUrl += `&showAvailableEventsOnly=${searchParams.showAvailableEventsOnly}`;
        }

        if (searchParams.showHighlight) {
            resourceUrl += `&showHighlight=${searchParams.showHighlight}`;
        }

        var results = await super.Get<PagedResults<EventDto>>(this.baseUrl, resourceUrl, accessToken);
        return results;
    }

    public async getEventSuggestions(searchTerm: string, accessToken: string): Promise<ServiceResponse<Array<string>>> {
        return await super.Get<Array<string>>(this.baseUrl, `suggestions?searchTerm=${searchTerm}`, accessToken);
    }

    public async getCategories(accessToken: string): Promise<ServiceResponse<Array<CategoryDto>>> {
        return await super.Get<Array<CategoryDto>>(this.baseUrl, `categories`, accessToken);
    }
}

export { EventsClient }